import type { Instance } from "@/server/types";
import { DISCONNECT_THRESHOLD } from "./types";

export const formatTime = (timestamp: number): string => {
  return new Date(timestamp).toLocaleTimeString();
};

export const getTimeAgo = (timestamp: number): string => {
  const seconds = Math.floor((Date.now() - timestamp) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

export const getStatusColor = (status: Instance["status"], connected: boolean): string => {
  if (!connected) return "bg-zinc-400";
  switch (status) {
    case "running":
      return "bg-green-500";
    case "idle":
      return "bg-yellow-500";
    case "error":
      return "bg-red-500";
  }
};

export const isConnected = (instance: Instance): boolean => {
  return Date.now() - instance.lastSeen < DISCONNECT_THRESHOLD;
};

export const generateId = (): string => {
  return Math.random().toString(36).substring(2, 10);
};

export const openImageInNewTab = (mimeType: string, base64Data: string) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });

  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
};
